import CameraUniCandidates from '@/data/CandidatiUninominaliCamera.json';
import SenateUniCandidates from '@/data/CandidatiUninominaliSenato.json';
import CameraPluriCandidates from '@/data/datiPoliticheCandidatiPluriCamera.json';
import SenatePluriCandidates from '@/data/datiPoliticheCandidatiPluriSenato.json';
import { getCameraLogo } from '@/lib/logosCamera';
import { getSenateLogo } from '@/lib/logosSenate';
import { Candidate, CoalitionCandidate, StructureType } from '@/lib/model';
import { getCoalitionColor, getCoalitionPosition } from './mockColors';

const reducePluriList = (
  list: typeof SenatePluriCandidates | typeof CameraPluriCandidates
) => {
  return list.reduce((acc: any, el) => {
    acc[el.cod_lis] = acc[el.cod_lis] || [];
    acc[el.cod_lis].push(el);
    return acc;
  }, {});
};

// Get pluri candidates list
export const getPluriCandidates = (type: StructureType) => {
  if (type === StructureType.SENATE) {
    return reducePluriList(SenatePluriCandidates);
  }

  return reducePluriList(CameraPluriCandidates);
};

// Get uni candidates list
export const getUniCandidates = (type: StructureType, collegeName: string) => {
  const list =
    type === StructureType.SENATE ? SenateUniCandidates : CameraUniCandidates;

  const pluriCandidates = getPluriCandidates(type);

  return list.coal.reduce((acc: Candidate[], el) => {
    const candidates = el.cand.filter(
      c => c.desc_cl_uni === collegeName.toUpperCase()
    );

    let partyName = el.desc_coal.toLowerCase();
    /**
     * Cod_coal = 17 for CAMERA
     * Cod_coal = 27 for SENATO
     */
    if (el.cod_coal === 17 || el.cod_coal === 27) {
      partyName = 'Centrosinistra';
    } else if (el.cod_coal === 22) {
      partyName = 'Centrodestra';
    }

    return [
      ...acc,
      ...candidates.map(candidate => ({
        fullName: `${candidate.nome} ${candidate.cogn}`.toLowerCase(),
        partyName,
        fillColor: getCoalitionColor(el.cod_coal),
        position: getCoalitionPosition(el.cod_coal),
        coalitions: el.liste.map(c => {
          let logo = getSenateLogo(c.img_lis);
          if (type === StructureType.CAMERA) {
            logo = getCameraLogo(c.img_lis);
          }

          const candidates = pluriCandidates[c.pos].filter(
            (c: CoalitionCandidate) =>
              c.desc_collegioP === candidate.desc_cl_plu
          );

          return {
            logo,
            candidates,
          };
        }),
      })),
    ];
  }, []);
};
